export default {
  methods: {
    reactivePush(list, obj) {
      this.$set(list, list.length, obj)
    },
    arrayOmitIndex(list, index) {
      if (index == 0) {
        return list.slice(1, list.length)
      }
      if (index == list.length - 1) {
        return list.slice(0, -1)
      }
      return [].concat(list.slice(0, index), list.slice(index + 1, list.length))
    },
  },
}